import {DefaultTheme} from 'styled-components';

import {isNotNil} from 'ramda';

import {ChartToolbarHighlights} from '../types/ChartToolbarHighlight';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {getChartHighlightBorderColor} from './getChartHighlightBorderColor';

interface ScatterDotStroke {
  stroke?: string;
  strokeOpacity?: number;
  strokeWidth?: number;
}

interface GetScatterDotStrokeParams {
  theme: DefaultTheme;
  car: ExtendedStatisticsCar | undefined;
  highlights: ChartToolbarHighlights;
  isMyAd: boolean;
  selectedSellerId: string | null;
}

export function getScatterDotStroke(params: GetScatterDotStrokeParams): ScatterDotStroke {
  if (params.isMyAd) {
    return {
      stroke: params.theme.colors.palettes.green['40']['100'],
      strokeOpacity: 0.4,
      strokeWidth: 16,
    };
  }

  const borderColor = getChartHighlightBorderColor({
    theme: params.theme,
    car: params.car,
    highlights: params.highlights,
    selectedSellerId: params.selectedSellerId,
  });

  if (isNotNil(borderColor)) {
    return {
      stroke: borderColor,
      strokeOpacity: 1,
      strokeWidth: 2,
    };
  }

  return {};
}
